class CtaBanner {
	constructor(selector = ".cta-banner") {
		this.banner = document.querySelector(selector)

		if (!this.banner) {
			return
		}

		this.image = this.banner.querySelector(".cta-image img")
		this.button = this.banner.querySelector(".cta-button")
		this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
		this.isDesktop = window.matchMedia("(min-width: 993px)").matches
		this.ticking = false

		this.init()
	}

	init() {
		this.reveal()
		this.bindRipple()

		if (this.prefersReducedMotion) {
			return
		}

		this.bindParallax()
		this.bindMouseMove()
	}

	reveal() {
		if (this.prefersReducedMotion || typeof IntersectionObserver === "undefined") {
			this.banner.classList.add("visible")
			return
		}

		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) {
						return
					}

					this.banner.classList.add("visible")
					observer.unobserve(entry.target)
				})
			},
			{ threshold: 0.2 }
		)

		observer.observe(this.banner)
	}

	bindParallax() {
		if (!this.image) {
			return
		}

		window.addEventListener(
			"scroll",
			() => {
				if (this.ticking) {
					return
				}

				window.requestAnimationFrame(() => this.updateParallax())
				this.ticking = true
			},
			{ passive: true }
		)
	}

	updateParallax() {
		const rect = this.banner.getBoundingClientRect()
		const windowHeight = window.innerHeight || document.documentElement.clientHeight

		if (rect.bottom < 0 || rect.top > windowHeight) {
			this.ticking = false
			return
		}

		const translateY = (rect.top / windowHeight) * -30
		this.image.style.transform = `translateY(${translateY}px)`
		this.ticking = false
	}

	bindMouseMove() {
		if (!this.isDesktop || !this.image) {
			return
		}

		this.banner.addEventListener("mousemove", event => this.handleMouseMove(event))
		this.banner.addEventListener("mouseleave", () => this.resetImagePosition())
	}

	handleMouseMove(event) {
		const rect = this.banner.getBoundingClientRect()
		const x = (event.clientX - rect.left) / rect.width
		const y = (event.clientY - rect.top) / rect.height
		const moveX = (x - 0.5) * 20
		const moveY = (y - 0.5) * 20

		this.image.style.transition = "transform .2s ease"
		this.image.style.transform = `translate(${moveX}px, ${moveY}px)`
	}

	resetImagePosition() {
		this.image.style.transition = "transform .6s ease"
		this.image.style.transform = "translate(0, 0)"
	}

	bindRipple() {
		if (!this.button) {
			return
		}

		this.button.addEventListener("click", event => this.createRipple(event))
	}

	createRipple(event) {
		const ripple = document.createElement("span")
		const size = Math.max(this.button.clientWidth, this.button.clientHeight)
		const rect = this.button.getBoundingClientRect()
		const oldRipple = this.button.querySelector(".cta-ripple")

		if (oldRipple) {
			oldRipple.remove()
		}

		ripple.className = "cta-ripple"
		ripple.style.width = `${size}px`
		ripple.style.height = `${size}px`
		ripple.style.left = `${event.clientX - rect.left - size / 2}px`
		ripple.style.top = `${event.clientY - rect.top - size / 2}px`

		this.button.appendChild(ripple)
	}
}

export default CtaBanner